var React = require('react');

function Offline (props) {
    return React.createElement("svg",props,React.createElement("circle",{"cx":"6","cy":"6","r":"6","fill":"#E20D17"}));
}

Offline.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = Offline;

Offline.default = Offline;
